// extracted by mini-css-extract-plugin
module.exports = {"box":"FJMainColorSwitch_box__1Eu5I","switch_bg":"FJMainColorSwitch_switch_bg__3B9cS","switch_active":"FJMainColorSwitch_switch_active__3-YgI"};